import axios from 'axios';
import { getToken } from '@/common/jwt.service';
/* eslint-disable */
// const baseURL = process.env.VUE_APP_BASE_URL || 'http://80.78.246.116:9988/api';
const baseURL = process.env.VUE_APP_BASE_URL_AI_API || 'https://tl.unionapp.ru/api/';
const instance = axios.create({ baseURL });

instance.interceptors.request.use((config) => {
  config.headers['Accept-Language'] = 'ru';
  config.headers['x_api_key'] = process.env.VUE_APP_AI_KEY;
  const token = getToken();
  if (token) config.headers.Authorization = `Token ${token}`;
//   if (token) config.headers.Authorization = `Token ${process.env.VUE_APP_AI_KEY}`;
  return config;
});

instance.interceptors.response.use(
  (resp) => resp.data,
  (err) => {
    if (err.response?.status >= 500) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        data: { server: [`Ошибка статус ${err.status}`] },
      });
    }
    if (err.response) {
      return Promise.reject(err.response);
    }
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      data: { not_server_response: ['Ошибка соединения с сервером'] },
    });
  },
);

export default instance;
